function Label() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>A Label is present.</p>
      <h4 className="h6 mb-3">A form label is present and associated with a form control.</h4>
      <p>A properly associated form label is presented to a screen reader user when the form control is accessed. Additionally, a label can be clicked with the mouse to set focus to the form control.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Ensure that the label is accurate, descriptive, succinct, and that it is associated with the correct form control element.</p>
    </blockquote>
  )
}

export default Label